export default function AppTextArea({ value, onChange, className, rows = 5, ...props }) {
  return <textarea value={value} onChange={(event) => onChange(event.target.value)} className={`form h-${rows * 4} ${className}`} {...props} />;
}
